<template>
  <el-select
    :value="value"
    filterable
    remote
    :remote-method="search"
    :loading="isSearching"
    :disabled="disabled"
    :placeholder="$t(`${I18N}.placeholder`)"
    :aria-label="$t(`${I18N}.label`)"
    size="small"
    class="measure-select"
    @change="select"
  >
    <el-option
      v-for="option in options"
      :key="option.id"
      :value="option.id"
      :label="option.description"
    />
  </el-select>
</template>

<script>
  import { measuresApi } from '@/api';
  import remoteOptionsMixin from './remoteOptionsMixin';

  // The unit of a mapping (REQ-09, REQ-11), searched by description as in the
  // value insertion form (FormOperationValue).
  export default {
    name: 'MeasureSelect',
    mixins: [remoteOptionsMixin],
    props: {
      value: { type: Number, default: null },
      // The selected unit, so its label shows before any search.
      measure: { type: Object, default: null },
      disabled: { type: Boolean, default: false },
    },
    data() {
      return {
        I18N: 'analysesData.importValues.columns.measure',
      };
    },
    computed: {
      selectedOption() {
        return this.measure;
      },
    },
    methods: {
      fetchOptions(query) {
        return measuresApi.autocompleteFetch(query);
      },
      select(id) {
        this.$emit('change', { measureId: id, measure: this.findOption(id) });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .measure-select {
    width: 100%;
  }
</style>
